let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2pex6")).then(() => parcelRequire('9wqJG'));